"use client";

import classnames from "classnames";
import { PropsWithChildren, ReactNode } from "react";
import Skeleton from "react-loading-skeleton";
import HideIf from "util/HideIf";
import styles from "./loaderSkeleton.module.scss";

interface IProps {
  count?: number;
  height?: number;
  className?: string;
  wrapperClass?: string;
  gridView?: boolean;
  wrapperHeight?: number | string;
  width?: number | string;
  classNameContainer?: string;
  gridViewNew?: boolean;
}
export default function LoaderSkeleton(props: IProps) {
  const {
    count = 1, height = "100%", className = "", wrapperClass, gridView = false,
    wrapperHeight, width = "100%", classNameContainer = "", gridViewNew = false,
  } = props;

  function Box({ children }: PropsWithChildren<ReactNode>) {
    if (!wrapperHeight) {
      return children;
    }
    return (
      <div
        className={wrapperClass}
        style={{
          height: wrapperHeight,
        }}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={classnames(styles.skeleton_container, {
        [styles.list_view]: !gridView,
        [styles.grid_view]: gridViewNew,
      })}
    >

      <HideIf show={gridView}>
        <div className={`${classNameContainer}`}>
          {Array.from({ length: count }, (_, idx) => (
            <Skeleton height={height} width={width} count={1} wrapper={Box} className={className} key={idx} />
          ))}
        </div>
      </HideIf>
      <HideIf show={!gridView}>
        <Skeleton height={height} width={width} count={count} wrapper={Box} className={className} />
      </HideIf>

    </div>
  );
}
